<template>
  <section>
    <v-btn
      color="indigo"
      dark
      block
      title="Historial de notificaciones"
      @click="abrirCerrarDialog()"
    >
      <v-icon>today</v-icon>
      Historial notificaciones
    </v-btn>
    <v-dialog
      width="1400"
      persistent
      v-model="dialog"
      transition="dialog-bottom-transition"
      :fullscreen="fullscreen"
    >
      <v-card class="pb-2">
        <v-form v-model="valid" ref="form" lazy-validation>
          <!-- Cabecera del formulario -->
          <v-card-title class="headline">
            <v-flex xs9> <v-icon>today</v-icon>HISTORIAL NOTIFICACIONES</v-flex>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click.native="
                () => {
                  fullscreen = !fullscreen;
                }
              "
            >
              <v-icon>fullscreen</v-icon>
            </v-btn>
            <v-btn icon @click.native="abrirCerrarDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-3 pb-4 mb-2">
            <v-layout row wrap align-space-between fill-height>
              <v-flex xs12 md8>
                <div class="calendar-container">
                  <div class="calendar">
                    <div
                      class="head-calendar layout row wrap align-center justify-space-between"
                    >
                      <div class="">
                        <div class="icon" @click="prevMonth">
                          chevron_left
                        </div>
                      </div>
                      <div class="">
                        <transition tag="div" :name="typeTransition">
                          <div :key="month" class="month-name">{{ month }}</div>
                        </transition>
                      </div>
                      <div class="" @click="nextMonth">
                        <div class="icon">chevron_right</div>
                      </div>
                    </div>

                    <div
                      class="days layout row wrap align-center justify-space-between"
                    >
                      <div
                        class="col col-center"
                        v-for="(day, index) in dayNames"
                        :key="`h-${index}`"
                      >
                        <div class="day-name">{{ day }}</div>
                      </div>
                    </div>
                    <div class="body" v-if="rows.length > 0">
                      <div
                        class="layout row wrap"
                        v-for="(row, index) in rows"
                        :key="`r-${index}`"
                      >
                        <div
                          class="col cell"
                          :class="[{ 'has-events': day.hasEvents }, day.type]"
                          v-for="(day, index) in row.days"
                          :key="`d-${index}`"
                          @click="updateDate(day)"
                        >
                          <transition-group tag="div" :name="typeTransition">
                            <div
                              :key="day.formattedDate"
                              class="day-number-month"
                            >
                              {{ day.formattedDate }}
                            </div>
                          </transition-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
              <transition tag="div" :name="!item_selected ? 'slide-right' : ''">
                <v-flex xs12 md4 v-show="!item_selected">
                  <div class="single-date">
                    <div class="head-date">
                      <div class="day-number">{{ selectedDay.number }}</div>
                      <div class="day-name">{{ selectedDay.name }}</div>
                    </div>
                    <div class="event-container">
                      <v-treeview
                        v-model="tree"
                        :open="open"
                        :items="dayEvents"
                        item-key="name"
                        open-on-click
                        dark
                        class="tree-content"
                      >
                        <template v-slot:prepend="{ item, active }">
                          <!-- Contador de notificaciones -->
                          <div
                            v-if="item.contador"
                            class="icono-contador"
                            @click="seleccionaItem(item)"
                          >
                            <div class="badge">{{ item.contador }}</div>
                            <v-icon :color="active ? 'primary' : ''">
                              mail
                            </v-icon>
                          </div>
                          <v-icon :color="active ? 'primary' : ''" v-else>
                            {{
                              item.nivel == 1
                                ? "today"
                                : item.nivel == 2
                                ? "person"
                                : "mail"
                            }}
                          </v-icon>
                        </template>
                        <template v-slot:label="{ item }">
                          <div>{{ item.name }}</div>
                          <div v-if="item.nombre_unidad"></div>

                          <div v-if="item.nro_tarea"></div>
                        </template>
                      </v-treeview>
                    </div>
                    <div
                      v-if="dayEvents.length == 0"
                      class="text-xs-center pt-3"
                    >
                      No existe registros
                    </div>
                    <div class="footer" v-if="dayEvents.length > 0">
                      <v-tooltip bottom>
                        <v-btn
                          outline
                          icon
                          slot="activator"
                          @click="crearExcel()"
                        >
                          <span class="material-symbols-outlined">
                            table_view
                          </span>
                        </v-btn>
                        <span>Exportar Excel</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-flex>
              </transition>
              <transition tag="div" :name="item_selected ? 'slide-right' : ''">
                <v-flex xs12 md4 v-if="item_selected">
                  <div class="detalle-notificacion ">
                    <div>
                      <v-btn
                        icon
                        @click.native="
                          () => {
                            item_selected = false;
                          }
                        "
                      >
                        <v-icon>arrow_back</v-icon>
                      </v-btn>
                    </div>
                    <div class="head-date">
                      <div class="day-number">{{ selectedDay.number }}</div>
                      <div class="day-name">{{ selectedDay.name }}</div>
                    </div>
                    <div class="text-xs-center">
                      <span>{{ item_selected.l_mensajes[0].nombres }}</span
                      ><br />
                      <span
                        >{{
                          $moment(
                            item_selected.l_mensajes[0].fecha_inicio
                          ).format("DD/MM/YYYY")
                        }}
                        -
                        {{
                          $moment(item_selected.l_mensajes[0].fecha_fin).format(
                            "DD/MM/YYYY"
                          )
                        }}</span
                      >
                    </div>
                    <!-- {{item_selected.l_mensajes}} -->
                    <div
                      class="mensaje"
                      v-for="(mensaje, index) in item_selected.l_mensajes"
                      :key="index"
                    >
                      <div
                        v-html="
                          mensaje.mensaje
                            .replace(/<br>\s*/g, '')
                            .replace(/<p>\s*/g, '<span>')
                            .replace(/<\/p>\s*/g, '</span>')
                            .replace(/<h1>\s*/g, '<h2>')
                            .replace(/<\/h1>\s*/g, '</h2>')
                        "
                      ></div>
                      <div class="text-xs-right indigo--text font-weight-bold">
                        {{ mensaje.nombre_usuario }}
                      </div>
                    </div>
                  </div>
                </v-flex>
              </transition>
            </v-layout>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
const XlsxPopulate = require("xlsx-populate");
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  props: ["lista_correos"],
  // Definición de componentes importados
  components: {},
  // Variables iniciales del componente
  data() {
    return {
      fullscreen: false,
      user: this.$storage.get("user"),
      loading: false,
      valid: true,
      dialog: false,
      currentMonth: new Date(),
      selectedDate: new Date(),
      transitionDirection: "",
      currentPage: {
        month: this.$moment().month(),
        year: this.$moment().year()
      },
      events: [],
      item_selected: undefined,
      // Variable tree view
      open: [],
      tree: []
    };
  },
  computed: {
    selectedDay() {
      return {
        number: this.$moment(this.selectedDate).format("D"),
        name: this.$moment(this.selectedDate).format("dddd")
      };
    },

    month() {
      const dateFormat = "MMMM YYYY";
      return this.$moment(this.currentMonth).format(dateFormat);
    },

    dayNames() {
      const dateFormat = "ddd";
      let startDate = this.$moment(this.currentMonth)
        .startOf("month")
        .startOf("isoWeek");

      const days = [];
      for (let i = 0; i < 7; i += 1) {
        days.push(
          this.$moment(this.$moment(startDate).add(i, "day"))
            .format(dateFormat)
            .substring(0, 1)
        );
      }
      return days;
    },
    rows() {
      const monthStart = this.$moment(this.currentMonth).startOf("month");
      const monthEnd = this.$moment(monthStart).endOf("month");
      const startDate = this.$moment(monthStart)
        .startOf("month")
        .startOf("isoWeek");
      const endDate = this.$moment(monthEnd)
        .endOf("month")
        .endOf("isoWeek");

      const dateFormat = "D";
      const rows = [];

      let days = [];
      let day = startDate;
      let formattedDate = "";

      while (day <= endDate) {
        for (let i = 0; i < 7; i += 1) {
          formattedDate = this.$moment(day).format(dateFormat);
          const dayInfo = {
            day,
            formattedDate,
            type: !this.$moment(day).isSame(monthStart, "month")
              ? "disabled"
              : this.$moment(day).isSame(this.selectedDate, "day")
              ? "selected"
              : "",
            hasEvents: this.findEvents(day).length > 0
          };
          days.push(dayInfo);
          day = this.$moment(day).add(1, "day");
        }
        rows.push({ days: days });
        days = [];
      }
      return rows;
    },
    dayEvents() {
      return this.findEvents(this.selectedDate, true);
    },
    typeTransition() {
      return `${
        this.transitionDirection === "next" ? "slide-left" : "slide-right"
      }`;
    }
  },
  watch: {
    currentPage(val, oldVal) {
      this.transitionDirection = this.getTransitionDirection(oldVal, val);
    }
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on("closeDialog", () => {});
    await this.cargarEventosMes();
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para cargar los detalles de las notificaciones
    async cargarDetalleNotificaciones(l_notificaciones) {
      try {
        let l_detalle_notificacion = await this.$service.graphql({
          query: `
						query{
							vHistorialNotificacionesPapeletass(l_fecha_notificacion:${JSON.stringify(
                l_notificaciones.map(
                  notificacion => notificacion.fecha_notificacion
                )
              )}){
								rows{
                  id_historial_notificacion
									id_persona
                  nombres
                  papeletas
                  fecha_inicio
                  fecha_fin
                  fecha_notificacion
                  mensaje
                  nombre_usuario
								}
							}
						}
					`
        });

        return l_detalle_notificacion.vHistorialNotificacionesPapeletass.rows;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para seleccionar el item
    async seleccionaItem(item) {
      if (JSON.stringify(this.item_selected) === JSON.stringify(item)) {
        this.item_selected = undefined;
      } else {
        this.item_selected = undefined;
        this.item_selected = item;
      }
    },
    async cargarEventosMes() {
      // Cargamos los events
      const monthStart = this.$moment(this.currentMonth).startOf("month");
      const monthEnd = this.$moment(monthStart).endOf("month");
      const startDate = this.$moment(monthStart)
        .startOf("month")
        .startOf("isoWeek")
        .format("YYYY-MM-DD");
      const endDate = this.$moment(monthEnd)
        .endOf("month")
        .endOf("isoWeek")
        .format("YYYY-MM-DD");
      let l_notificaciones = (
        await this.$query.selectConsulta(
          "listaFechasNotificacionPapeletasVacacion",
          { fecha_inicio: startDate, fecha_fin: endDate },
          ["rows"]
        )
      ).rows;
      // Cargamos detalle de eventos del dia
      let l_detalle_notificacion = await this.cargarDetalleNotificaciones(
        l_notificaciones
      );
      // Agrupamos el detalle por fechas
      l_notificaciones.forEach(padre => {
        padre.name = `${this.$moment(padre.fecha_inicio).format(
          "DD/MM/YYYY"
        )} - ${this.$moment(padre.fecha_fin).format("DD/MM/YYYY")}`;
        padre.nivel = 1;
        // Primero agrupamos personas
        const personas = l_detalle_notificacion
          .filter(
            detalle =>
              detalle.fecha_notificacion == padre.fecha_notificacion &&
              detalle.fecha_inicio == padre.fecha_inicio &&
              detalle.fecha_fin == padre.fecha_fin
          )
          .reduce((unique, current) => {
            const exists = unique.find(
              obj => obj.id_persona === current.id_persona
            );
            if (!exists) {
              unique.push({
                id_persona: current.id_persona,
                nombres: current.nombres
              });
            }
            return unique;
          }, [])
          .sort((a, b) => {
            if (a.nombres < b.nombres) {
              return -1;
            }
            if (a.nombres > b.nombres) {
              return 1;
            }
            return 0;
          });
        // Relacionamos personas con la fechas
        padre.children = personas;
        // Ahora recorremos las notificaciones que se enviaron en la fecha
        padre.children.forEach(persona => {
          persona.name = persona.nombres;
          persona.nivel = 2;
          // Agrupamos notificaciones y mensajes
          var l_mensajes = l_detalle_notificacion.filter(noti => {
            noti.nivel = 3;
            return (
              noti.id_persona === persona.id_persona &&
              noti.fecha_notificacion == padre.fecha_notificacion &&
              noti.fecha_inicio == padre.fecha_inicio &&
              noti.fecha_fin == padre.fecha_fin
            );
          });
          persona.children = this.agruparNotificacionesMensajes(l_mensajes);
          // persona.mensajes = l_mensajes;
        });
      });
      // Cargamos el datalle de cada notificacion
      this.events = l_notificaciones;
    },
    // Metodo para agrupar las notificaciones
    agruparNotificacionesMensajes(l_notificaciones) {
      return l_notificaciones.reduce((unique, current) => {
        const exists = unique.find(obj =>
          this.sonArraysIguales(
            obj.papeletas.split(";"),
            current.papeletas.split(";")
          )
        );
        if (!exists) {
          unique.push({
            l_mensajes: [JSON.parse(JSON.stringify(current))],
            contador: 1,
            nivel: current.nivel,
            papeletas: current.papeletas,
            name: `${current.papeletas.replace(/;/g, " - ")}`
          });
        } else {
          exists.contador++;
          exists.l_mensajes.push(JSON.parse(JSON.stringify(current)));
        }
        return unique;
      }, []);
    },
    // Metodo para saber si 2 arrays son iguales
    sonArraysIguales(array1, array2) {
      // Ordenar los arrays y convertirlos a cadenas
      const cadenaArray1 = JSON.stringify(array1.sort());
      const cadenaArray2 = JSON.stringify(array2.sort());
      // Comparar las cadenas para verificar si son iguales
      return cadenaArray1 === cadenaArray2;
    },

    async nextMonth() {
      this.currentMonth = this.$moment(this.currentMonth).add(1, "month");
      await this.cargarEventosMes();
      this.updateCurrentPage(this.currentMonth);
    },

    async prevMonth() {
      this.currentMonth = this.$moment(this.currentMonth).subtract(1, "month");
      await this.cargarEventosMes();
      this.updateCurrentPage(this.currentMonth);
    },

    updateDate(day) {
      this.item_selected = undefined;
      this.selectedDate = day.day;
    },

    updateCurrentPage(date) {
      this.currentPage = {
        month: this.$moment(date).month(),
        year: this.$moment(date).year()
      };
    },

    findEvents(day, sort = false) {
      let hasEvents = this.events.reduce((list, ev) => {
        if (
          this.$moment(day).format("YYYY-MM-DD") ==
          this.$moment(ev.fecha_notificacion).format("YYYY-MM-DD")
        ) {
          ev.active = false;
          list.push(ev);
        }
        return list;
      }, []);
      if (sort) {
        hasEvents.sort((a, b) => {
          const dateA = new Date(a.fecha_inicio);
          const dateB = new Date(b.fecha_fin);
          return this.$moment(dateA).isBefore(dateB);
        });
      }

      return hasEvents;
    },

    getTransitionDirection(fromPage, toPage) {
      if (!fromPage || !toPage) return "";
      if (fromPage.year !== toPage.year)
        return fromPage.year < toPage.year ? "next" : "prev";
      if (fromPage.month !== toPage.month)
        return fromPage.month < toPage.month ? "next" : "prev";
      return "";
    },
    // Metodo para cerrar o abrir el dialog
    abrirCerrarDialog() {
      this.contador_correos_enviados = 0;
      this.sw_envio_correos = false;
      this.dialog = this.dialog ? false : true;
    },
    // Metodo para exportar a un excel
    async crearExcel() {
      var fecha_seleccionada = this.$moment(this.selectedDate).format(
        "YYYY-MM-DD"
      );
      let l_notificaciones = await this.$query.select(
        "v_historial_notificaciones_papeletas",
        { fecha_notificacion: fecha_seleccionada },
        [
          "nombres",
          "fecha_notificacion",
          "rango_inicio:fecha_inicio",
          "rango_fin:fecha_fin",
          "papeletas",
          "mensaje",
          "nombre_usuario"
        ]
      );
      // Ordenamos lista segun los nombres
      let jsonData = l_notificaciones.sort((a, b) => {
        if (a.nombres < b.nombres) {
          return -1;
        }
        if (a.nombres > b.nombres) {
          return 1;
        }
        return 0;
      });
      // Damos formato a los mensajes
      jsonData.forEach(element => {
        element.mensaje = element.mensaje.replace(/<[^>]+>/g, "");
      });
      let titulo = `NOTIFICACIONES PAPELETAS VACACIONES ${this.$moment(
        this.selectedDate
      ).format("DD/MM/YYYY")}`;
      // Crear un nuevo libro de Excel
      XlsxPopulate.fromBlankAsync()
        .then(workbook => {
          const sheet = workbook.sheet(0);
          sheet
            .cell("A1")
            .style({
              fontSize: 18,
              bold: true,
              fontColor: "1D4F91"
            })
            .value(titulo);
          // Creamos cabecera
          let json_object = jsonData[0];
          var codigoAscii = 65; //LETRA A
          for (const key in json_object) {
            sheet
              .cell(`${String.fromCharCode(codigoAscii)}${2}`)
              .value(key.toUpperCase());
            codigoAscii++;
          }
          // Creamos cuerpo
          const data = jsonData.map(obj => Object.values(obj));
          sheet.cell("A3").value(data); // Datos
          return workbook.outputAsync();
        })
        .then(blob => {
          // Crear un nuevo Blob con el contenido del archivo Excel
          var fecha_descarga = this.$moment(this.selectedDate).format(
            "DD_MM_YYYY"
          );
          const excelBlob = new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.sp"
          });
          let url = window.URL.createObjectURL(excelBlob);
          let a = document.createElement("a");
          a.href = url;
          a.download = `NOTIFICACIONES_PAPELETAS_VACACION_${fecha_descarga}.xlsx`;
          document.body.appendChild(a);
          a.click();
        })
        .catch(error => {
          console.error("Error al crear el archivo Excel:", error);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.icon {
  font-family: "Material Icons", serif;
  font-style: normal;
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  text-rendering: optimizeLegibility;
  font-feature-settings: "liga";
  user-select: none;
}

/* VARIABLES */

$main-color: #024572e8;
$text-color: #2d70a7c9;
$text-color-light: #cccccc;
$hover-color: #97e2f577;
$neutral-color: #ffffff;
$event-color: rgb(36, 214, 89);
/* GRID */

.col {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}
.col-start {
  justify-content: flex-start;
  text-align: left;
}
.col-center {
  justify-content: center;
  text-align: center;
}
.col-end {
  justify-content: flex-end;
  text-align: right;
}
.calendar-container {
  position: sticky;
  top: 0;
}
/* Calendar */
.calendar {
  display: block;
  width: 100%;
  background: $neutral-color;
  z-index: 2;
  .head-calendar {
    text-transform: capitalize;
    font-weight: 400;
    font-size: 120%;
    padding: 1.5em 0;
    align-items: center;

    .icon {
      cursor: pointer;
      user-select: none;
      transition: 0.15s ease-out;

      &:hover {
        transform: scale(1.75);
        transition: 0.25s ease-out;
        color: $main-color;
      }

      &:first-of-type {
        margin-left: 2rem;
      }

      &:last-of-type {
        margin-right: 2rem;
      }
    }

    .col {
      flex-shrink: 1;
      flex-basis: auto;
    }

    .month-name {
      font-size: 2rem;
      color: $main-color;
    }
  }
  .days {
    text-transform: uppercase;
    font-weight: 700;
    color: $main-color;
    padding: 0.75rem 0;
    // font-size: 0.9rem;
    .col {
      padding: 0 1rem;
    }

    .day-name {
      padding: 0.25rem 0;
    }

    & .selected {
      .day-name {
        font-weight: 700;
        border-bottom: 2px solid $main-color;
      }
    }
  }

  .body {
    .cell {
      position: relative;
      background: $neutral-color;
      padding: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px rgba(0, 102, 236, 0.137);
      :last-child {
        border-right: none;
      }
      &:hover {
        background: rgba(77, 211, 252, 0.274);
      }

      &.has-events {
        &:after {
          position: absolute;
          content: "";
          width: 1rem;
          height: 1rem;
          background-color: $event-color;
          top: 8px;
          right: 23px;
          // border-radius: 0.5rem;
          border: 2px solid $neutral-color;
        }
      }

      .day-number-month {
        line-height: 1;
        font-weight: 700;
        padding: 0.75rem;
        width: 42px;
        text-align: center;
        font-size: 1.5rem;
        cursor: pointer;
        border-radius: 0.25rem;
        &:hover {
          background: $hover-color;
        }
      }
    }

    .col {
      flex-grow: 0;
      color: $text-color;
      flex-basis: (100% / 7);
      width: (100% / 7);
    }
    .selected {
      & .day-number-month {
        background-color: $main-color;
        color: $neutral-color;

        &:hover {
          background-color: $main-color;
          color: $neutral-color;
        }
      }
    }
    .disabled {
      color: $text-color-light !important;
      pointer-events: none;
    }
  }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.25s ease-in-out;
}
.slide-left-leave-active,
.slide-right-leave-active {
  position: absolute;
}
.slide-left-enter,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(50px) translateZ(0);
}
.slide-left-leave-to,
.slide-right-enter {
  opacity: 0;
  transform: translateX(-50px) translateZ(0);
}
.head-date {
  position: sticky;
  top: 0;
  backdrop-filter: blur(8px);
  z-index: 3;
  .day-number {
    padding-top: 1rem;
    font-size: 4rem;
    line-height: 1;
    text-align: center;
  }
  .day-name {
    text-transform: uppercase;
    border-bottom: solid 1px $neutral-color;
    text-align: center;
  }
}
//Metodos para el dia solo
.single-date {
  padding: 1rem;
  background: $main-color;
  color: $neutral-color;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .footer {
    align-self: flex-end;
    margin-top: auto;
    position: sticky;
    bottom: 5px;
    .v-btn {
      color: rgba(3, 231, 182, 0.616);
      background: rgba(0, 46, 32, 0.466) !important;
      position: relative !important;
      backdrop-filter: blur(1px);
      &:hover {
        transform: scale(1.4);
        color: rgb(22, 231, 3);
        box-shadow: 0px 0px 10px rgba(69, 255, 63, 0.788) !important;
        backdrop-filter: blur(4px);
      }
    }
  }
}
.detalle-notificacion {
  background: mediumaquamarine;
  padding: 1rem;
  min-height: 100%;
  color: $neutral-color;
  z-index: 1;
  .mensaje {
    line-height: 1;
    font-size: 0.8rem;
    padding: 0.5rem 0rem;
    border-bottom: solid 1px $neutral-color;
    border-top: solid 1px $neutral-color;
    & * {
      font-size: inherit;
      padding: 0;
      margin: 0;
    }
  }
}
.tree-content {
  // * {
  //   color: rgba(255, 255, 255, 0.781);
  //   letter-spacing: -0.05rem;
  //   // font-size: 1.2rem;
  //   // white-space: pre-wrap !important;
  // }
  color: white;
  .icono-contador {
    display: flex;
    align-items: center;
    .badge {
      background: rgba(255, 0, 89, 0.55);
      font-size: 0.7em;
      text-align: center;
      border-radius: 50%;
      padding: 0rem 0.5rem;
      display: flex;
      font-weight: 600;
      align-items: center;
      width: 1.3rem; /* Ancho del círculo */
      height: 1.3rem;
      margin-right: -0.3rem;
      z-index: 2;
    }
  }
  .v-treeview-node__root {
    text-overflow: ellipsis !important;
    white-space: nowrap;
    overflow-x: hidden !important;
    color: rgba(255, 255, 255, 0.781);
    letter-spacing: -0.05rem;
  }
  .v-icon {
    color: rgba(9, 221, 221, 0.747) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/components/CalendarioNotificaciones.vue